export enum MemberHsaTransferType {
  Accept = 'TRANSFER_IN',
  Decline = 'TRANSFER_OUT',
  Hide = 'HIDE',
  NoLiquidation = 'NO_LIQUIDATION',
}

export const SUPPORT_CONSOLIDATE_HSA_LINK =
  'https://support.joinforma.com/en/articles/6763541-consolidate-your-hsa-money-if-you-enroll-for-2023';

export const SUPPORT_HOW_TO_SELL_ALEGEUS_HSA_INVESTMENTS =
  'https://support.joinforma.com/en/articles/6766066-how-do-i-sell-investments-on-my-wealthcare-portal';

export const SUPPORT_HSA_FAQ_LINK =
  'https://support.joinforma.com/en/articles/6859853-forma-hsa-faqs-new-forma-hsa';

export const SUPPORT_HOW_TO_DO_INDIVIDUAL_TRANSFER =
  'https://support.joinforma.com/en/articles/6907486-how-do-i-transfer-my-hsa-balance-to-forma-myself';

export const SUPPORT_HOW_TO_DO_INDIVIDUAL_TRANSFER_V2 =
  'https://support.joinforma.com/en/articles/7128390-how-do-i-transfer-my-hsa-balance-to-forma-myself';

export const ALEGEUS_GROUP_ONE_INFO_LINK =
  'https://drive.google.com/file/d/1BBHzxfYzmaEdSzOm1yk6Tz64QVB4iKi0/view';

export const ALEGEUS_GROUP_TWO_INFO_LINK =
  'https://drive.google.com/file/d/1fA2COI2W2kyppe_210Nae7iBwv40l-z4/view';

export const ALEGEUS_HSA_INVESTMENTS_SELL_DEADLINE = '2023-02-17';

// Group of companies who will be cut off from alegeus hsa access on 3/9/23 instead of 3/2/23
// https://linear.app/forma/issue/PRT-2963/tandc-blackout-date-update
export const ALEGEUS_GROUP_TWO = ['samsara', 'udemy', 'better_up', 'zoom'];

export const ALEGEUS_GROUP_ONE_ACCESS_DATE = '2023-03-02';
export const ALEGEUS_GROUP_TWO_ACCESS_DATE = '2023-03-09';
export const ALEGEUS_INDIVIDUAL_TRANSFER_REMINDER_LAST_DATE = '2023-04-03'; //prt-35822
